import { render, staticRenderFns } from "./PidCheck.vue?vue&type=template&id=6a2d573a&scoped=true"
import script from "./PidCheck.vue?vue&type=script&lang=js"
export * from "./PidCheck.vue?vue&type=script&lang=js"
import style0 from "./PidCheck.vue?vue&type=style&index=0&id=6a2d573a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2d573a",
  null
  
)

export default component.exports